export const capitalizeFirstLetters = (string) =>
    string.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase());

export const NOT_FOUND_MESSAGE = 'Page not found';
export const NOT_AUTHORIZED_APPLICATION_MESSAGE =
    "You're not authorized to access the application.";
export const NOT_AUTHORIZED_SCREEN_MESSAGE = "You're not authorized to view this screen.";
